// Module
var code = `{{#visible}}
<div class="alert-selector">
    <terceraLabel text="{{label}}" />

    <div class="alert-selector-right">
        <terceraInstrumentLookup isSetDefaultInstrument="false" mayContainTrees="true" selectedItem="{{instrument}}" selectedAccount="{{account}}" isSymbolInfoOpened="{{isSymbolInfoOpened}}"/>
    </div>
</div>
{{/}}`;
// Exports
export default code;